<template>
  <div>
    <div
      :class="typeItemClass"
      v-for="(releaseNotesForType, type) in releaseNotes"
      :key="type"
    >
      <h2>{{ type ? type : 'Release Notes' }}</h2>
      <ul class="top-level">
        <li
          v-for="(item, index) in releaseNotesForType"
          :key="index"
          :class="item.date ? 'date-title' : ''"
        >
          <span v-if="item.date">{{ (type === 'Known Issues' ? 'Due by ' : '') + item.date }}</span>
          <ul>
            <li
              v-for="(note, index) in item.releaseNotes"
              :key="index"
              class="note"
            >
              {{ note.module.toUpperCase().trim() }}:
              <span v-html="note.description" />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    releaseNotes: {
      type: Object,
      required: true,
    },
    typeItemClass: {
      type: String,
      required: false,
    },
  },
}
</script>

<style scoped>
ul.top-level {
  margin: 0.75em 0;
  padding: 0 1em;
  list-style: none;
}

li.date-title:before {
  content: '';
  border-color: transparent #0e3e71;
  border-style: solid;
  border-width: 0.35em 0 0.35em 0.45em;
  display: block;
  left: -0.8em;
  top: 1.1em;
  position: relative;
}

li.date-title > span,
h2 {
  color: #0e3e71;
}

li.note {
  list-style-type: disc;
}
</style>
